import { useDialogState } from '@finviz/website'
import React from 'react'

export const withDialogState = (Component: any) => (props: any) => {
  const confirmationDialogState = useDialogState()
  const noteDialogState = useDialogState({ modal: false })

  return <Component confirmationDialogState={confirmationDialogState} noteDialogState={noteDialogState} {...props} />
}
